export default {
  setCategories(state, categories) {
    state.categories = categories;
  },
  setCourses(state, courses) {
    state.courses = courses;
  },
  setArchives(state, archives) {
    state.archives = archives;
  },
  setLesson(state, lesson) {
    state.lesson = lesson;
  },
  setLessons(state, lessons) {
    state.lessons = lessons;
  },
  setLive(state, live) {
    state.live = live;
  },
  setFeatured(state, featured) {
    state.featured = featured;
  },
  setCourse(state, course) {
    state.course = course;
  },
  setFreebies(state, freebies) {
    state.freebies = freebies;
  },
  setCount(state, count) {
    state.count = count;
  },
  setArchivesCount(state, archivesCount) {
    state.archivesCount = archivesCount;
  },
  setProduct(state, product) {
    state.product = product;
  }
};
